import axios from 'axios'
import { APIINV as API } from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/entradas`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  entradaJSON(id, params) {
    params = params || {}
    return apiClient.get(`${id}.json`, { params: params })
  },

  entradasJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/entradas.json`, { params: params })
  },

  guardar(entrada) {
    return apiClient.post('', entrada)
  },
}